import React, {useEffect, useMemo, useRef, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {Dialog, DialogActions, DialogContent, DialogTitle, Step, StepLabel, Stepper} from "@mui/material";
import TextFieldValidation from "../table/customer-detales/TextFieldValidation";
import ButtonExit from "../button/ButtonExit";
import ButtonAdd from "../button/ButtonAdd";
import MenuItem from "@mui/material/MenuItem";
import ModulesTable from "../../../pages/common/settings/ModulesTable";
import ModuleController from "../../../API/organization/ModuleController";
import CompositionController from "../../../API/organization/CompositionController";
import {Box} from "@mui/system";
import {withFilter} from "../../../data/FilterTables/withFilterHOC";
import {ModulesFilterData} from "../../../data/FilterTables/ModulesFilterData";
import ButtonBack from "../button/ButtonBack";
import {flattenModuleCompositionRow} from "../../../utils/flattenModuleCompositionRow";
import {enrichModuleCompositionRow} from "../../../utils/enrichModuleCompositionRows";
import {asArray} from "../../../utils/asArray";
import {pickKitchenCompositionId, rememberKitchenCompositionId} from "../../../utils/withCompositionIdQuery";
import {comparePriority} from "../../../utils/comparePriority";

const initValidation = {
    "name": "", "width": "",
    "height": "",
    "depth": "",
    "minWidth": "",
    "minHeight": "",
    "minDepth": "",
    "maxWidth": "",
    "maxHeight": "",
    "maxDepth": ""
}
const steps = [
    'Модуль',
    'Размеры'
];
const ModalModule = ({
                         open,
                         onClose,
                         handleSubmit,
                         initValue,
                         title,
                         loading,
                         sideBaseModuleList,
                         heightLocationModuleList,
                         moduleId,
                         dependentModuleCompositionId,
                         compositionId,
                         handleModalAlert,
                         composition
                     }) => {
    const ComponentModulesWithFilter = useMemo(() => {
        return withFilter(ModulesTable, ModulesFilterData);
    }, []);
    const [activeStep, setActiveStep] = useState(0)
    const [data, setData] = useState([]);
    const [formState, setFormState] = useState(initValue)
    const [validationState, setValidationState] = useState(initValidation)
    const [selectedString, setSelectedString] = useState(null)
    const moduleList = composition ? [['LEFT', 'Слева'], ['RIGHT', 'Справа']] : sideBaseModuleList

    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const selectExisting = Boolean(moduleId || dependentModuleCompositionId)
    const pickerDialogWidth = dependentModuleCompositionId
        ? "calc(576px + (100vw - 120px - 576px) * 4 / 5 + 48px)"
        : ((selectExisting || composition) && activeStep === 0) ? "calc(100vw - 48px)" : 400
    const [searchParams] = useSearchParams()
    const kitchenCompositionId = pickKitchenCompositionId(
        compositionId,
        searchParams.get("compositionId"),
    )
    const selectRequestRef = useRef(0)

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
    }

    const handleSelectModalRow = (row) => {
        setSelectedString(row)
        if (!dependentModuleCompositionId || row?.moduleId == null) {
            return
        }
        const requestId = ++selectRequestRef.current
        enrichModuleCompositionRow(row).then((merged) => {
            if (requestId !== selectRequestRef.current) {
                return
            }
            setSelectedString((prev) => (prev?.id === row.id ? merged : prev))
            setData((prev) => prev.map((item) => (item.id === row.id ? merged : item)))
        })
    }

    useEffect(() => {
        if (!open) {
            return
        }
        setFormState(initValue);

        if (dependentModuleCompositionId) {
            if (kitchenCompositionId == null) {
                handleModalAlert({message: "Не удалось загрузить список: нет id композиции"})
                return
            }
            rememberKitchenCompositionId(kitchenCompositionId)
            CompositionController.getForDependModuleComposition(kitchenCompositionId).then(function (response) {
                const raw = Array.isArray(response.data)
                    ? response.data
                    : (Array.isArray(response.data?.content)
                        ? response.data.content
                        : asArray(response.data?.moduleCompositions))
                const rows = raw
                    .map(flattenModuleCompositionRow)
                    .filter((row) => row?.id != null)
                    .sort((a, b) => comparePriority(a.priority, b.priority))
                setData(rows);
                setSelectedString(rows[0] ?? null)
                setTableOptions((prev) => ({...prev, totalElements: rows.length}))
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
            return
        }

        (moduleId || composition) && ModuleController.get().then(function (response) {
            setData(response.data);
            setSelectedString(response.data[0])
            setTableOptions((prev) => ({...prev, totalElements: response?.data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [open, dependentModuleCompositionId, kitchenCompositionId, moduleId, composition])

    const handleClose = () => {
        setFormState(initValue)
        onClose()
        setValidationState(initValidation)
        setActiveStep(0)
    }

    const handleValidationData = () => {
        if (activeStep === 0 && composition) {
            setFormState({
                ...formState,
                sideBaseModule: !["CORNER_LEFT", "CORNER_RIGHT"].includes(selectedString.sideBaseModule) ? "LEFT" : selectedString.sideBaseModule,
                width: selectedString.width,
                height: selectedString.height,
                depth: selectedString.depth
            })
            setActiveStep(1)
        } else {
            if (moduleId || dependentModuleCompositionId) {
                const selectedId = selectedString?.moduleCompositionId ?? selectedString?.id
                if (selectedId == null) {
                    return
                }
                handleSubmit(selectedId, handleClose)
            } else if (composition) {
                handleSubmit(selectedString.id, formState, handleClose, selectedString)
            } else {
                const newErrors = {...validationState}

                Object.entries(formState).forEach(([name, value]) => {

                    if (value === "" && name !== "groupName") {
                        newErrors[name] = "пустое поле"
                    }
                })

                setValidationState(newErrors)

                if (Object.values(newErrors).every(el => el === "")) {
                    handleSubmit(formState, handleClose)
                }
            }
        }

    }
    return (
        <Dialog
            open={open}
            maxWidth={false}
            PaperProps={{
            sx: {
                width: pickerDialogWidth,
                maxWidth: pickerDialogWidth,
                overflow: "hidden",
                borderRadius: 8,
            }
        }}>
            <Box style={{
                padding: "16px 24px",
                display: "flex",
                flexDirection: "column",
                gap: 16,
                alignItems: "center"
            }}>
                <DialogTitle sx={{
                    color: (theme) => theme.palette.text.main,
                    padding: 0,
                    fontSize: 24,
                    fontWeight: 700
                }}>{title}</DialogTitle>
                {composition && <Stepper
                    style={{width: 330}}
                    activeStep={activeStep}
                >
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel sx={{
                                ".MuiSvgIcon-root": {
                                    fontSize: 40,
                                    color: "#737478",
                                    "&.Mui-active": {
                                        color: "#3B8BEC",
                                    }
                                },
                                "& .MuiStepLabel-label": {
                                    fontSize: 18,
                                    "&.Mui-active": {
                                        fontWeight: 700,
                                    }
                                }
                            }}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>}
            </Box>
            <DialogContent sx={{overflow: "auto", width: "100%", maxWidth: "100%", boxSizing: "border-box"}}>
                {((selectExisting || composition) && activeStep === 0) ? <ComponentModulesWithFilter
                        handleModalAlert={handleModalAlert}
                        tableOptions={tableOptions}
                        tableOptionsHandle={tableOptionsHandle}
                        data={data}
                        setData={setData}
                        isModal={true}
                        dependentModuleCompositionId={dependentModuleCompositionId}
                        selectedString={selectedString}
                        setSelectedString={dependentModuleCompositionId ? handleSelectModalRow : setSelectedString}/> :
                    <Box>
                        {activeStep === 0 && <>
                            <TextFieldValidation
                                name={"name"}
                                type={"text"}
                                value={formState?.name}
                                label={"Наименование"}
                                setCurrValues={setFormState}
                                validationError={validationState?.name}
                                setValidationState={setValidationState}
                            />
                            <TextFieldValidation
                                name={"groupName"}
                                type={"text"}
                                value={formState?.groupName}
                                label={"Группа"}
                                setCurrValues={setFormState}
                                required={false}
                            />
                        </>}
                        {(activeStep === 0 || !["CORNER_LEFT", "CORNER_RIGHT"].includes(selectedString.sideBaseModule)) &&
                            <TextFieldValidation
                                select
                                label="Расположение"
                                value={formState?.sideBaseModule}
                                setCurrValues={(getData) => setFormState(prev => ({
                                    ...prev,
                                    sideBaseModule: getData()
                                }))}
                                width={"370px"}
                                required={false}
                            >
                                {moduleList?.map((option) => (
                                    <MenuItem key={option[0]} value={option[0]}>
                                        {option[1]}
                                    </MenuItem>
                                ))}
                            </TextFieldValidation>
                        }
                        {activeStep === 0 && <TextFieldValidation
                            select
                            label="Расположение по высоте"
                            value={formState?.heightLocation}
                            setCurrValues={(getData) => setFormState(prev => ({
                                ...prev,
                                heightLocation: getData()
                            }))}
                            width={"370px"}
                            required={false}
                        >
                            {heightLocationModuleList?.map((option) => (
                                <MenuItem key={option[0]} value={option[0]}>
                                    {option[1]}
                                </MenuItem>
                            ))}
                        </TextFieldValidation>
                        }
                        <TextFieldValidation
                            name={"width"}
                            type={"number"}
                            value={formState?.width}
                            label={"Ширина"}
                            setCurrValues={setFormState}
                            validationError={validationState?.width}
                            setValidationState={setValidationState}
                        />
                        <TextFieldValidation
                            name={"height"}
                            type={"number"}
                            value={formState?.height}
                            label={"Высота"}
                            setCurrValues={setFormState}
                            validationError={validationState?.height}
                            setValidationState={setValidationState}
                        />
                        <TextFieldValidation
                            name={"depth"}
                            type={"number"}
                            value={formState?.depth}
                            label={"Глубина"}
                            setCurrValues={setFormState}
                            validationError={validationState?.depth}
                            setValidationState={setValidationState}
                        />
                        {activeStep === 0 && <>
                            <TextFieldValidation
                                name={"minWidth"}
                                type={"number"}
                                value={formState?.minWidth}
                                label={"Минимальная ширина"}
                                setCurrValues={setFormState}
                                validationError={validationState?.minWidth}
                                setValidationState={setValidationState}
                            />
                            <TextFieldValidation
                                name={"minHeight"}
                                type={"number"}
                                value={formState?.minHeight}
                                label={"Минимальная высота"}
                                setCurrValues={setFormState}
                                validationError={validationState?.minHeight}
                                setValidationState={setValidationState}
                            />
                            <TextFieldValidation
                                name={"minDepth"}
                                type={"number"}
                                value={formState?.minDepth}
                                label={"Минимальная глубна"}
                                setCurrValues={setFormState}
                                validationError={validationState?.minDepth}
                                setValidationState={setValidationState}
                            />
                            <TextFieldValidation
                                name={"maxWidth"}
                                type={"number"}
                                value={formState?.maxWidth}
                                label={"Максимальная ширина"}
                                setCurrValues={setFormState}
                                validationError={validationState?.maxWidth}
                                setValidationState={setValidationState}
                            />
                            <TextFieldValidation
                                name={"maxHeight"}
                                type={"number"}
                                value={formState?.maxHeight}
                                label={"Максимальная высота"}
                                setCurrValues={setFormState}
                                validationError={validationState?.maxHeight}
                                setValidationState={setValidationState}
                            />
                            <TextFieldValidation
                                name={"maxDepth"}
                                type={"number"}
                                value={formState?.maxDepth}
                                label={"Максимальная глубна"}
                                setCurrValues={setFormState}
                                validationError={validationState?.maxDepth}
                                setValidationState={setValidationState}
                            />
                        </>}
                    </Box>}
            </DialogContent>
            <DialogActions style={{padding: 40, display: "flex", justifyContent: "space-between"}}>
                <Box>{activeStep !== 0 &&
                    <ButtonBack text={"Назад"}
                                onClick={() => setActiveStep(0)}/>} </Box>
                <Box>
                    <ButtonExit text={"Выйти"} onClick={handleClose}/>
                    <ButtonAdd
                        loading={loading}
                        text={initValue?.id ? "Изменить" : "Добавить"} onClick={handleValidationData}/>
                </Box>
            </DialogActions>
        </Dialog>
    );
}
export default ModalModule